module.exports = __webpack_public_path__ + "img/client30.b47b8b4d.svg";